import { render } from "./Scoreboard.vue?vue&type=template&id=40aa515d&ts=true"
import script from "./Scoreboard.vue?vue&type=script&lang=ts"
export * from "./Scoreboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__